import {ARRAYLAYER} from './ArrayLayerTypes'

const initialState = {
    arrayLayer : [{}]
}

const ArrayLayerReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case ARRAYLAYER:
            
            return {
                arrayLayer : action.load
            }
    
        default:
          return state
    }

}

export default ArrayLayerReducer;